import { t } from "@travily/i18n";
import { Illustration } from "@ui/components/Illustration";

export function EmptyConversationView() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 p-8 text-center">
      <Illustration className="w-48" name="messages" />
      <p className="max-w-xs text-base text-neutral-500">
        {t("components.views.messages.empty_conversation_view.prompt")}
      </p>
    </div>
  );
}
